import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'side-menu',
    data: { title: 'Purchase Reports - Home' },
    loadChildren: () => import('./components/side-menu/side-menu.module').then(m => m.SideMenuPageModule)
  },
  {
    path: 'home',
    data: { title: 'Purchase Reports - Home' },
    loadChildren: () => import('./components/home-tabs/home/home.module').then(m => m.HomeModule)
  },
  {
    path: '**', redirectTo: 'side-menu/hometabs/tabs/home', pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
